/* eslint-disable no-useless-escape */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-new-func */

export const getFieldCalculation = (formula, answers) => {
  const noWsStr = formula?.replace(/\s+/g, '');
  const arrayValues = noWsStr?.split(/([()\+\-\*\/])/)?.filter(arr => arr!=='') || [];
  let variable = '';
  const replaceArray = arrayValues?.map((arr) => {
    variable = answers && Object.keys(answers).find(a => a === arr);
    if (variable && answers[variable]?.toString()?.length && variable!==undefined) {
      return answers[variable]?.toString();
    }
    if (!Number.isNaN(Number(arr))) {
      return arr;
    }
    if (/^[^a-zA-Z0-9]+$/.test(arr)) {
      if (arr.match(/([()\+\-\*\/])/) || arr.match(/\d+[0-9]/)) {
        return arr;
      }
    }
    return '0';
  });
  const joinArray = replaceArray.join('');
  try {
    let func = new Function(`return ${joinArray}`);
    return func();
  } catch (err) {
    return false;
  }
};

export const handleCalculation = (fields, answers, fromMultiGrid, allFields, multiFieldId,
  formApprovalSteps, exposeFieldsList, exposeFieldsData) => {
    let calculation = '';
    let formula = '';
    let valueArray = [];
    const getCalcFieldKey = field => field?.calc_field_id || field?.meta_data?.calc_field_id;
    if (fromMultiGrid) {
        const activeMultiFieldId = typeof multiFieldId === 'string' ? multiFieldId : multiFieldId?.id;
        const multiGridFields = allFields?.filter(e => (
          e.type === 'multi_field' && (!activeMultiFieldId || activeMultiFieldId === e.id)));
        if (multiGridFields) {
          multiGridFields.forEach((e) => {
            const multipleFields = Object.keys(e?.multiple_fields)?.map(i => ({ ...e?.multiple_fields[i], id: i }));
            const calcFields = multipleFields?.filter(field => field?.type?.key === 'calculation');
            const numberFields = multipleFields?.filter(field => field?.type?.key === 'number' || field?.type?.key === 'select'
              || field?.type?.key === 'calculation');
            if (calcFields?.length > 0) {
              let result = {};
              let resultArray = [];
              calcFields.forEach(async (field) => {
                formula = field.calculation;
                // eslint-disable-next-line no-useless-escape
                const formulaValues = formula?.replace(/\s+/g, '')?.split(/([()\+\-\*\/])/)?.filter(arr => arr!=='') || [];
                const formulaValueArray = numberFields?.filter(num => formulaValues?.filter(
                  arr => ((getCalcFieldKey(num) === arr) || (num.id === arr))
                )?.length > 0);
                if (formulaValueArray?.length > 0) {
                  resultArray = formulaValueArray?.map((num) => {
                    const calcFieldKey = getCalcFieldKey(num);
                    // Check if we have a live calculation (Eg: Number + Calculation) in 'result' from a previous step (dependent field).
                    // If not, fall back to the initial value from 'answers'.
                    const currentVal = result[calcFieldKey] !== undefined
                    ? result[calcFieldKey]
                    : answers[num.id];

                    const resultCodedValues = numberFields.find(val => getCalcFieldKey(val) === calcFieldKey)?.type?.key === 'select'
                    ? numberFields.find(val => getCalcFieldKey(val) === calcFieldKey)?.values?.find(v => v.key === answers[num.id])?.coded_value
                    : currentVal;
                    result[calcFieldKey || num.id] = resultCodedValues;
                    return result;
                  });
                }
                const answerValues = resultArray?.length > 0 ? resultArray?.[0] : answers;
                calculation = getFieldCalculation(formula, answerValues);
                // this line ensures that the calculated value is stored in the result object under the respective key
                result[getCalcFieldKey(field)] = calculation;
                valueArray.push({ value: calculation, id: field.id });
              });
            }
          });
        }
      } else {
        const calculationFields = fields?.filter(field => field.type === 'calculation') || [];
        let numberFields = fields?.filter(field => ((field.type === 'select' || field.type === 'number'
          || field.type === 'calculation') && field?.meta_data?.calc_field_id));
        if (calculationFields?.length > 0) {
          let result = {};
          let resultArray = [];
          let cleanAnswer = answers || {};
          const exposeData = exposeFieldsData || {};
          calculationFields.forEach((field) => {
            if (formApprovalSteps && field?.id.startsWith('d')) {
              numberFields = numberFields.filter(item => item.id.startsWith('d'));
            } else if (formApprovalSteps && field?.id.startsWith('ex')) {
              numberFields = exposeFieldsList?.filter(f => ((f.type === 'select' || f.type === 'number'
                || f.type === 'calculation'
              ) && f?.meta_data?.calc_field_id));
              Object.keys(answers).forEach((key) => {
                if (key.startsWith('ex-Forms-')) {
                  const formKey = key.replace('ex-Forms-', '');
                  if (formKey in exposeData) {
                    exposeData[formKey] = answers[key];
                  }
                }
              });
              cleanAnswer = exposeData;
            }
          formula = field.meta_data?.form_calculation?.calculation;
          // Wrap variables in parentheses to prevent errors when subtracting negative numbers (e.g., converting --2 to -(-2)).
          formula = formula.replace(/\b([A-Z]\d+)\b/g, '($1)');
          // eslint-disable-next-line no-useless-escape
          const formulaValues = formula?.replace(/\s+/g, '')?.split(/([()\+\-\*\/])/)?.filter(arr => arr!=='') || [];
          const formulaValueArray = numberFields?.filter(num => formulaValues?.filter(
            arr => ((num.meta_data?.calc_field_id === arr) || (num.id === arr))
          )?.length > 0);
          if (formulaValueArray?.length > 0) {
            resultArray = formulaValueArray?.map((num) => {
              let resultCodedValues;
              if (numberFields.find(val => val.id === num.id)?.type === 'select') {
                resultCodedValues = numberFields.find(val => val.id === num.id)?.values?.find(v => v.key === cleanAnswer[num.id])?.coded_value;
              } else {
                const calcId = num.meta_data?.calc_field_id;
                resultCodedValues = result[calcId] !== undefined ? result[calcId] : cleanAnswer[num.id];
              }
              result[num.meta_data?.calc_field_id || num.id] = resultCodedValues;
              return result;
               });
          }
          const answerValues = resultArray?.length > 0 ? resultArray?.[0] : cleanAnswer;
          calculation = getFieldCalculation(formula, answerValues);
          // this line ensures that the calculated value is stored in the result object under the respective key
          result[field?.meta_data?.calc_field_id] = calculation;
          valueArray.push({ value: calculation, id: field.id });
        });
        }
    }
      return valueArray;
  };

export const getPhoneConvert = (answer) => {
  const answerValue = typeof answer === 'string' ? answer : `${answer || ''}`;
  const hasPlus = answerValue.trim().startsWith('+');
  const numericValue = answerValue.replace(/[^\d]/g, '');
  const countryCodeMatch = answerValue.match(/^\+([0-9]{1,3})[() -]/);
  const inferredCountryCodeLen = Math.min(Math.max(numericValue.length - 10, 0), 3);
  const countryCodeLen = countryCodeMatch ? countryCodeMatch[1].length : inferredCountryCodeLen;
  const convertValidtorValueToRegex = `^\\+[0-9]{${10 + countryCodeLen}}$`;
  const phoneValConvert = hasPlus ? `+${numericValue}` : answerValue[0] + answerValue.slice(1).replace(/[^\d]/g, '');
  return { phoneValConvert, convertValidtorValueToRegex };
};

export const hasMapLocationCoordinates = (value) => {
    if (!value) return false;

    if (Array.isArray(value)) {
      return value.some(item => hasMapLocationCoordinates(item));
    }

    if (typeof value !== 'object') return false;

    if (Array.isArray(value?.coordinates)) {
      return value.coordinates.length > 0;
    }

    if (value?.map_location) {
      return hasMapLocationCoordinates(value.map_location);
    }

    if (value?.locations || value?.polygons || value?.polylines) {
      return ['locations', 'polygons', 'polylines'].some(
        key => hasMapLocationCoordinates(value?.[key])
      );
    }

    return false;
};

export const getHasMapLocation = (fields, formData) => (
    (fields || []).some((field) => {
      if (field?.type === 'map_location') {
        return hasMapLocationCoordinates(formData?.[field.id]);
      }

      if (field?.type === 'dataSourceMultiLevel' && field?.dataSourceID === 'ds2') {
        return hasMapLocationCoordinates(formData?.[field.id]?.map_location);
      }

      return false;
    })
);

export const getFieldError = (val, fieldId, placeHolders, invalidEmailCount = 0, isMultipleEmail = false) => {
  let fieldError='';
  if (val === 'Email') {
     if (isMultipleEmail && invalidEmailCount > 0) {
      fieldError = `${invalidEmailCount} ${invalidEmailCount === 1 ? 'Email' : 'Emails'} format is incorrect.`;
    } else {
      fieldError = 'Email format is incorrect.';
    }
  } else if (val === 'Phone Number') {
    fieldError = 'Please enter a valid phone number.';
  } else if (val === 'Custom Validation') {
    fieldError = `Custom validation format is incorrect. Valid format is ${placeHolders[fieldId]}`;
  }
  return fieldError;
};

export const handleMultiFieldErrorList = (fieldType, answer, fieldId, prevState) => {
  const updatedErrorListMCG = { ...(prevState?.errorListMCG || {}) };
  (Array.isArray(answer) ? answer : []).forEach((a, index) => {
    Object.keys(a).forEach((val) => {
      const validator = fieldType?.multiple_fields?.[val]?.validator;
      if (validator) {
        let convertValidtorValueToRegex = validator.value;
        let phoneValConvert = '';
        if (validator.key === 'Phone Number') {
          ({ phoneValConvert, convertValidtorValueToRegex } = getPhoneConvert(a[val]));
        }
        const regexValue = new RegExp(convertValidtorValueToRegex);
        const validateRegex = (value) => {
          if (!value || !value.trim()) {
            return { hasError: false, invalidCount: 0 };
          }

          if (validator?.multiple_email) {
            const emailList = value
              .split(',')
              .filter(e => typeof e === 'string')
              .map(e => e.trim());

            const invalidEmails = emailList.filter(
              email => !regexValue.test(email)
            );

            return {
              hasError: invalidEmails.length > 0,
              invalidCount: invalidEmails.length
            };
          }

          const isInvalid = !regexValue.test(value.trim());
          return {
            hasError: isInvalid,
            invalidCount: isInvalid ? 1 : 0
          };
        };
        if (Object.prototype.hasOwnProperty.call(a, val)) {
          const { hasError, invalidCount } = validateRegex(phoneValConvert || a[val]);

          if (hasError) {
            const fieldError = getFieldError(
              validator.key,
              fieldId,
              {},
              invalidCount,
              !!validator?.multiple_email
            );

            updatedErrorListMCG[fieldId] = {
              ...updatedErrorListMCG[fieldId],
              [index]: {
                ...(updatedErrorListMCG[fieldId]?.[index] || {}),
                [val]: fieldError
              }
            };
          } else if (updatedErrorListMCG[fieldId]?.[index]?.[val]) {
            delete updatedErrorListMCG[fieldId][index][val];

            if (!Object.keys(updatedErrorListMCG[fieldId][index]).length) {
              delete updatedErrorListMCG[fieldId][index];
            }
            if (!Object.keys(updatedErrorListMCG[fieldId]).length) {
              delete updatedErrorListMCG[fieldId];
            }
          }
        }
        // text area max length validation
        if (fieldType.multiple_fields?.[val]?.text_aera
          && fieldType.multiple_fields?.[val]?.validator?.key ? (fieldType.multiple_fields?.[val]?.validator?.key === 'None') : true) {
          if (a?.[val]?.length > fieldType.multiple_fields?.[val]?.validation_limit) {
              updatedErrorListMCG[fieldId] = {
              ...updatedErrorListMCG[fieldId],
              [index]: {
                ...(updatedErrorListMCG[fieldId]?.[index] || {}),
                [val]: 'Character limit exceeded'
              }
            };
        }
}
      }
    });
  });
  return updatedErrorListMCG;
};

export const getSectionByItem = (data, value) => {
  const sections = [];
  let currentSection = [];
  if (!data?.length) return [];
  data.forEach((item) => {
      if (item.type === 'header') {
          if (currentSection.length > 0) {
              sections.push(currentSection);
          }
          currentSection = [item];
      } else {
          currentSection.push(item);
      }
  });
  if (currentSection.length > 0) {
    sections.push(currentSection);
  }
  if (value === 'getAllSections') {
      return sections;
  }
  const selectedSection = value?.id ? sections?.find(section => section.some(field => field.id === value?.id)) : sections[sections.length-1];
  return selectedSection?.filter(field => field.id !== value?.id) || [];
};
